import { Component } from '@angular/core';
import { BaseIndexPageComponent } from 'src/app/components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from 'src/app/components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from 'src/app/components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from 'src/app/components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from 'src/app/services/api/api-options.config';
import { CampaignsService } from 'src/app/services/api/campaigns.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-campaign-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './campaigns-index-page.component.html',
  styleUrl: './campaigns-index-page.component.scss'
})
export class CampaignIndexPageComponent {
  list: any[] = [];
  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected campaignsService: CampaignsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Campaigns',
      cardTitle: 'Manage Campaigns',
      addNewItemButton: {
        type: 'success',
        title: 'Add Campaign',
        onClick: () => {
          this.routeService.campaignCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => {
              return item.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => {
              return item.name;
            }
          }),
           new DataTableColumnText({
            attribute: 'validFrom',
            header: 'Valid From',
            filter: 'text',
            value: (item: any) => {
              return item.startTime;
            }
          }),
           new DataTableColumnText({
            attribute: 'validTo',
            header: 'Valid To',
            filter: 'text',
            value: (item: any) => {
              return item.endTime;
            }
          }),
           new DataTableColumnText({
            attribute: 'discount',
            header: 'Discount %',
            filter: 'text',
            value: (item: any) => {
              return item.discountPercent;
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View campaign details',
                onClick: (item: any) => {
                  this.routeService.campaignDetail(item.campaignId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit campaign',
                onClick: (item: any) => {
                  this.routeService.campaignUpdate(item.campaignId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete campaign',
                onClick: (item: any) => {
                  this.baseIndexPageConfig.dataTable.data = this.baseIndexPageConfig.dataTable.data.filter((campaign: any) => campaign.campaignId !== item.campaignId);
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.campaignsService.list(options),
      responseListModelName: 'campaigns',
    }
  }
}
